// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JobApplyButton_wrapper__zUm4_"};